export default "__VITE_ASSET__CRxh_rYD__"